import {
  Box,
  Button,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
} from "@mui/material";
import { PageHeader } from "../../../components/PageHeader";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import {
  followSocialPage,
  getFollowingFacebookPages,
} from "../../../api/specialization/SocialSpecializationAPI";
import { OptionsObject, useSnackbar } from "notistack";
import { AlertSuccessProp } from "../../../components/SnackbarNoti";
import TrendzContainerCard from "../../../components/TrendzContainerCard";

export default function FacebookManagementPage() {
  const { t } = useTranslation(["common", "social", "keyword"]);
  const [openDialog, setOpenDialog] = useState(false);
  const [pageUrl, setPageUrl] = useState("");
  const [followingPages, setFollowingPages] = useState([]);
  const [forceReload, setForceReload] = useState(false);
  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    getFollowingFacebookPages().then((res) => {
      setFollowingPages(res);
      console.log(followingPages);
    });
  }, [forceReload]);

  var rows = followingPages.map((page) => {
    var chip = <Chip label={t("common:" + page["reportStatus"])}></Chip>;
    if (page["reportStatus"] == "UNPROCESSED") {
      chip = (
        <Chip label={t("common:" + page["reportStatus"])} color="error"></Chip>
      );
    }
    if (page["reportStatus"] == "PROCESSED") {
      chip = (
        <Chip
          label={t("common:" + page["reportStatus"])}
          color="success"
        ></Chip>
      );
    }
    return (
      <TableRow key={page["id"]}>
        <TableCell
          style={{
            paddingTop: "10px",
            paddingBottom: "10px",
          }}
          sx={{ fontWeight: "500 !important" }}
        >
          {page["name"] ? page["name"] : t("common:unknown")}
        </TableCell>
        <TableCell style={{ paddingTop: "10px", paddingBottom: "10px" }}>
          {page["url"]}
        </TableCell>
        <TableCell style={{ paddingTop: "10px", paddingBottom: "10px" }}>
          {chip}
        </TableCell>
        <TableCell
          style={{
            paddingTop: "8px",
            paddingBottom: "8px",
            paddingLeft: "10px",
            paddingRight: "10px",
          }}
          sx={{ align: "center" }}
        ></TableCell>
      </TableRow>
    );
  });
  return (
    <TrendzContainerCard title={t("social:facebook_follow_page")}>
      <Grid item xs={0.75}></Grid>
      <Grid container xs={10.5} className="">
        <Box
          display={"flex"}
          justifyContent={"flex-begin"}
          marginBottom={"20px"}
        >
          <Button
            variant="contained"
            color="success"
            style={{ width: "120px", marginRight: "30px" }}
            onClick={() => {
              setOpenDialog(true);
            }}
          >
            {t("common:follow")}
          </Button>
        </Box>
        <Dialog
          open={openDialog}
          onClose={() => {
            setOpenDialog(false);
          }}
          maxWidth="md"
          fullWidth
        >
          <DialogTitle>{t("keyword:follow_facebook_page")}</DialogTitle>
          <DialogContent>
            <TextField
              margin="dense"
              id="name"
              label={t("keyword:fanpage_url")}
              placeholder={t("keyword:fanpage_url").toString()}
              fullWidth
              required
              variant="standard"
              onChange={(e) => {
                setPageUrl((e.target as HTMLInputElement).value);
              }}
            ></TextField>
            <DialogActions sx={{ marginTop: "20px" }}>
              <Button
                variant="contained"
                onClick={() => {
                  followSocialPage(pageUrl, "SOCIAL", "facebook").then(
                    (res) => {
                      enqueueSnackbar(
                        t("common:update_successfully"),
                        AlertSuccessProp as OptionsObject
                      );
                      setForceReload(!forceReload);
                    }
                  );
                  setOpenDialog(false);
                }}
              >
                Submit
              </Button>
            </DialogActions>
          </DialogContent>
        </Dialog>
        <TableContainer component={Paper}>
          <Table>
            <colgroup>
              <col style={{ width: "25%" }} />
              <col style={{ width: "30%" }} />
              <col style={{ width: "20%" }} />
              <col style={{ width: "20%" }} />
            </colgroup>
            <TableHead>
              <TableRow>
                <TableCell sx={{ fontWeight: "600 !important" }}>
                  {t("social:fanpage_name")}
                </TableCell>
                <TableCell sx={{ fontWeight: "600 !important" }}>
                  {t("social:fanpage_url")}
                </TableCell>
                <TableCell sx={{ fontWeight: "600 !important" }}>
                  {t("social:status")}
                </TableCell>
                <TableCell
                  sx={{
                    align: "center",
                    textAlign: "center",
                    fontWeight: "600 !important",
                  }}
                >
                  {t("common:actions")}
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>{rows}</TableBody>
          </Table>
        </TableContainer>
      </Grid>
      <Grid item xs={0.75}></Grid>
    </TrendzContainerCard>
  );
}
